<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  created() {
    this.$store.dispatch('init', this.$route.query);
  },
  mounted(){
    document.title = this.$store.state.game_name;
  }
}
</script>

<style>
@media screen and (min-width:1000px){ 
  html {
    width: 960px;
    margin: 0 auto;
  }
}
html,body{
  background-color: rgb(20, 23, 40);
  min-width: 320px;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/App.vue